export function mapInventoryComponentsToSubitems(components) {
  if (!Array.isArray(components)) return []

  return components.map(c => ({
    ...c,
    itemTypeID: c.id,
    quantity: c.quantity ?? 0,
    quantity2: c.quantity2 ?? 0,
    defaultUnitAmount: c.defaultUnitAmount || 1,
    variantID: c.selectedVariantID || 0,
    variantName: c.variantName || '',
  }))
}
